import { Button, cn } from "@tellescope/design-system";
import { formatFileSize } from "@tellescope/utils";
import { Trash } from "lucide-react";

export interface FileCardProps {
  name: string;
  type?: string;
  size: number;
  onDelete?: () => void;
  deleteLabel?: string;
  className?: string;
}

export const FileCard = ({ name, type, size, onDelete, deleteLabel, className }: FileCardProps) => {
  return (
    <div
      className={cn(
        "group/file flex items-center justify-between gap-4 rounded-lg border bg-muted/40 px-4 py-3",
        className
      )}
      data-testid="contact-details-block-item"
    >
      <div className="flex min-w-0 flex-col gap-1">
        <span className="truncate text-sm font-medium text-foreground">{name}</span>
        <span className="truncate text-xs text-muted-foreground">{type}</span>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <span className="whitespace-nowrap text-sm text-muted-foreground">{formatFileSize(size)}</span>
        {onDelete && (
          <Button
            variant="ghost"
            color="muted"
            size="sm"
            iconOnly
            hoverLabel={deleteLabel}
            className="opacity-0 transition-opacity group-hover/file:opacity-100"
            onClick={onDelete}
          >
            <Trash />
          </Button>
        )}
      </div>
    </div>
  );
};
